<template>
  <header>
    <div class="info">
      <span class="h-role" @click="checkTeacher">
        <i class="icon iconfont icon-jinhangzhong" v-if="!headerData.isQA"></i>
        {{(headerData.role === 0 || headerData.role === "教学区") ? "教师端" : "学生端"}}
      </span>
      <span class="h-role" v-if="headerData.isQA" @click="checkStudent">
        <i class="icon iconfont icon-jinhangzhong" v-if="headerData.isQA"></i>
        {{headerData.nameQA}}
        <i class="icon iconfont icon-guanbi" @click="closeQA"></i>
      </span>
      <span v-if="headerData.roomId" class="h-id">教室ID：{{headerData.roomId}}</span>
      <span v-if="headerData.number" class="h-num">在线人数：{{headerData.number}}</span>
    </div>
    <div class="">
      <!-- <span class="" @click="issueQuestion">发布问卷</span> -->
      <!-- <span class="">反馈</span>
      <span class="">学生提问</span> -->
    </div>
    <div class="action">
      <slot></slot>
    </div>
  </header>
</template>

<script>
import EventBus from '@/views/eventBus'
export default {
  props: {
    headerData: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    console.log(this.headerData)
  },
  methods: {
    initOptions () {
      if (this.headerData === undefined) {
        this.headerData = {}
      }
    },
    issueQuestion() {
      this.$emit('issueQuestionnaire', this.$route.params.languageId)
    },
    checkTeacher() {
    },
    checkStudent() {
    },
    closeQA() {
      console.log('closeQA')
      EventBus.$emit('closeQAMenu')
    }
  }
}
</script>

<style lang="scss" scoped>
header{
  border-bottom: 1px solid #c1c1c1;
  height: 48px;
  line-height: 48px;
  padding: 0 36px;
  background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
  background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
  overflow-x: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  .info{
    color: #FFF;
    font-size: 16px;
    float: left;
    span{
      padding: 0 12px;
      border-right: 2px solid #FFF;
      font-weight: 300;
    }
    span:last-child{
      border-right: 2px solid transparent;
    }
    .h-role{
      font-weight: normal;
    }
    .h-id{
      
    }
    .h-num{
      color: rgba(255, 255, 255, 0.6)
    }
  }
  .action{
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?dfdc2514